import React, { useEffect, useState } from 'react';
import { Bounce } from 'react-reveal';
import { Button, Dropdown, Form, Icon, Input, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import GConf from '../../AssetsM/generalConf';
import BreadCrumb from '../Assets/breadCrumb'
import useGetFamilleArticle from '../Assets/Hooks/fetchArticlesFamille'
import useGetArticles from '../Assets/Hooks/fetchArticles';
import axios from 'axios';
 

 

function AddArticleStock() {
    /*#########################[Const]##################################*/
    const [familles,allFamille] = useGetFamilleArticle()   
    const [articles] = useGetArticles()  
    const [articleD, setArticleD] = useState({ Prix:'0'});
    const [saveBtnState, setSaveBtnState] = useState('')
    const [loaderState, setLS] = useState(false)
     
    
    /*#########################[Functions ]##################################*/
     
    const SaveArticle = (event) => {
            if (!articleD.A_Code) {toast.error("Code à barre Invalide !", GConf.TostErrorGonf)}
            else if (!articleD.Name || articleD.Name == '') {toast.error("Name Invalide !", GConf.TostErrorGonf)}
            else if (!articleD.Genre) {toast.error("Genre Invalide !", GConf.TostErrorGonf)}
            else if (!articleD.Prix) {toast.error("Prix Vente Invalide !", GConf.TostErrorGonf)}
            else if (!articleD.Quantite) {toast.error("Quantite Invalide !", GConf.TostErrorGonf)}
            
            else{
                setLS(true)
                axios.post(`${GConf.ApiLink}/stock/ajouter`, {
                    PID : GConf.PID,
                    articleD : articleD,
                }).then(function (response) {
                    if(response.data.affectedRows) {
                        setSaveBtnState('disabled')
                        toast.success("Article Enregistreé !", GConf.TostSuucessGonf)
                        setLS(false)
                        
                    }
                    else{
                        toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
                        setLS(false)
                    }
                }).catch((error) => {
                    if(error.request) {
                      toast.error(<><div><h5>Probleme de Connextion</h5>   </div></>, GConf.TostInternetGonf)   
                       
                    }
                  });
                
            }
            
    } 
    const checkArticleExistance = () =>{
        if(articleD.A_Code){
            if(articles.includes(parseInt(articleD.A_Code))) {
                toast.error("Article Exist Deja", GConf.TostErrorGonf)
                setArticleD({...articleD, A_Code: '' })
            } 
        }
    }
    const OnKeyPressFunc = (e) => {
        const charCode = e.charCode;

        const isEnglish =
            (charCode >= 65 && charCode <= 90) || // A-Z
            (charCode >= 97 && charCode <= 122);  // a-z

        const isNumber = charCode >= 48 && charCode <= 57;
        const isSpecial = charCode === 42 || charCode === 32 || charCode === 47;

        const isArabic =
            (charCode >= 0x0600 && charCode <= 0x06FF) || // Arabic block
            (charCode >= 0x0750 && charCode <= 0x077F) || // Arabic Supplement
            (charCode >= 0x08A0 && charCode <= 0x08FF);   // Arabic Extended-A

        if (!(isEnglish || isNumber || isSpecial || isArabic)) {
            e.preventDefault();
        }
        };

    

    return ( <>

            <BreadCrumb links={GConf.BreadCrumb.stockAddArticle} />
            <br />
            <Bounce left>
                <div className='row'>
                    <div className='col-12 col-lg-8'>
                        <h5 className='mb-1'>Code à barre:</h5>
                        <Input icon='barcode' iconPosition='left' type='number' placeholder='code a barre' className='w-100 border-0 shadow-sm rounded mb-3' onKeyPress={event => OnKeyPressFunc(event)} onBlur={checkArticleExistance} value={articleD.A_Code} onChange={(e) => setArticleD({...articleD, A_Code: e.target.value })} />
                        <div className='row'>
                            <div className='col-12 col-lg-8'>
                                <h5 className='mb-1'>Nom: </h5>
                                <Input icon='star' iconPosition='left' placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-3' onKeyPress={event => OnKeyPressFunc(event)} value={articleD.Name}  onChange={(e) => setArticleD({...articleD, Name: e.target.value })}/>
                            </div>
                            <div className='col-12 col-lg-4'>
                                <h5 className='mb-1'>Genre: </h5>
                                <Dropdown className='w-100 shadow-sm rounded mb-3' placeholder='Famille' search fluid selection options={familles} onChange={(e, data) => setArticleD({...articleD, Genre: data.value })} />
                            </div>
                        </div> 
 
                    <div className='row'>
                                
                                <div className='col-12 col-lg-6'>
                                    <h5 className='mb-1'>Prix  : </h5>
                                    <Input icon='dollar' iconPosition='left' type='number' placeholder='Prix' value={articleD.Prix}  className='w-100 border-0 shadow-sm rounded mb-3' onChange={(e) => setArticleD({...articleD, Prix: e.target.value })}/>
                                </div>
                                <div className='col-12 col-lg-6'>
                                    <h5 className='mb-1'>Quantité: </h5>
                                    <Input icon='dropbox' iconPosition='left' type='number' placeholder='quantité' value={articleD.Quantite} className='w-100 border-0 shadow-sm rounded mb-3' onChange={(e) => setArticleD({...articleD, Quantite: e.target.value })}/> 
                                </div>
                                 
                    </div> 
                    <div className='row d-none'>
                                <div className='col-12 col-lg-9'>
                                    <h5 className='mb-1'>Quantité: </h5>
                                    <Input icon='dropbox' iconPosition='left' type='number' placeholder='quantité' className='w-100 border-0 shadow-sm rounded mb-3' onChange={(e) => setArticleD({...articleD, Qte: e.target.value })}/> 
                                </div>
                                <div className='col-12 col-lg-3'>
                                    <h5 className='mb-1'>Repture En: </h5>
                                    <Input icon='angle double down' iconPosition='left' type='number' placeholder='repture' className='w-100 border-0 shadow-sm rounded mb-3' onChange={(e) => setArticleD({...articleD, Repture: e.target.value })}/>
                                </div>
                                 
                    </div>
                        
                        <div className='text-end mb-5'>
                            <Button onClick={SaveArticle}  className={`text-end rounded-pill bg-system-btn ${saveBtnState}`}  positive>  <Icon name='save outline' /> Enregistrer <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                        </div>
                    </div>
                    <div className='col-lg-4 '>
                        <div className='text-center d-none d-lg-block  align-self-center'>
                                <img src='https://assets.ansl.tn/Images/usful/articles-add.svg' width='80%'  height='200px' /> 
                        </div> 
                    </div>
                </div>
            </Bounce>
    </> );
}

export default AddArticleStock;